import React from 'react';
import Cancle_btn from '../common/common_btn/cancle_btn/Cancle_btn';
import Sumbit_btn from '../common/common_btn/submit_btn/Sumbit_btn';
import Policy_banner from '../common/policy_banner/Policy_banner';

function Privacy_Policy() {
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "Privacy Policy", link: "", isActive: true },
    ];

    return (
        <>
            <Policy_banner
                breadcrumbs={breadcrumbs}
                headingText="Privacy Policy"
                imgSrc="/assets/images/policy_banner/privacy_policy/privacy_policy_banner.png"
            />
            <div className="container">
                <div className="content_holder">
                    <div className="text_holder">
                        <p>
                            UrbanBuild is committed to protecting your privacy. This Privacy Policy explains how we collect, use,
                            share, and safeguard your personal information when you use our mobile application.
                        </p>
                    </div>
                    <div className="list_holder">
                        <ul>
                            <li>
                                <div className="text_holder">
                                    <h6>1. Information We Collect</h6>
                                    <p>
                                        We collect your name, contact details, location, and service preferences to help connect you with
                                        the right vendors or experts. Vendors and experts may also share shop or service info for profile listings.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="text_holder">
                                    <h6>2. How We Use Your Information</h6>
                                    <p>
                                        Your data is used to create your account, manage inquiries, send notifications, and improve your overall
                                        experience on the platform.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="text_holder">
                                    <h6>3. Sharing Your Information</h6>
                                    <p>
                                        We only share your information with relevant vendors or service providers when you submit a request.
                                        We don’t sell your data to anyone.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="text_holder">
                                    <h6>4. Data Security</h6>
                                    <p>
                                        We use encryption and secure storage to protect your personal information, but encourage users
                                        to also use strong passwords and stay alert.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="text_holder">
                                    <h6>5. Cookies & Tracking</h6>
                                    <p>
                                        We may use cookies to analyze usage and personalize your experience.
                                        You can manage cookie settings in your browser.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="text_holder">
                                    <h6>6. Your Rights</h6>
                                    <p>
                                        You can update or delete your profile at any time. You also have the right to request access
                                        to your data or opt out of promotional messages.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="text_holder">
                                    <h6>7. Data Retention</h6>
                                    <p>
                                        We keep your data as long as your account is active or as needed for legal and operational reasons.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="text_holder">
                                    <h6>8. Children’s Privacy</h6>
                                    <p>
                                        UrbanBuild is for users aged 18 and above. We do not knowingly collect information from minors.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="text_holder">
                                    <h6>9. Policy Updates</h6>
                                    <p>
                                        We may update this policy occasionally. Any major changes will be shared via app or email notifications.
                                    </p>
                                </div>
                            </li>
                            <li>
                                <div className="text_holder">
                                    <h6>10. Contact Us</h6>
                                    <p>
                                        For privacy-related questions, contact us at Info.touristjunction@gmail.com or visit our office in Pune, Maharashtra.
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="btn_holder">
                        <Cancle_btn btnText="Decline" />
                        <Sumbit_btn btnText="Accept" />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Privacy_Policy;
